<template>
  <b-card class="no-border">

  </b-card>
</template>

<script>
  export default {
    created() {
      this.$store.commit('SET_BREADCRUMB_ITEMS', [
        { to: '', name: 'Home' },
        { to: 'employees', name: 'Employees' },
      ]);

      this.$store.commit('employees/CLEAR_QUERY');
      this.$store.dispatch('employees/LOAD_INFO');
      this.$store.dispatch('employees/LOAD_DATA');
    },
  };
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/pages/employee/Index.vue